<!--
 * @FileDescription: 自定义LineWrapper组件
 * @Author: 朱建波
 * @Date: 2023-11-27
 * @LastEditors: 朱建波 342393950@qq.com
 *
 * @name: ZLineWrapper
 *
 * @Props
 * @property {Boolean} list                是否显示为列表形式
 * @property {Number} column               显示列数
 * @property {Boolean} min                 最小宽度值
 * @property {Boolean} vertical            是否换行
 * @property {Boolean} reverse             标签和内容反色
 * @property {String} labelWidth           标签宽度
 * @property {String} labelAlign           标签内容水平对齐方式
 * @property {String} labelVerticalAlign   标签内容垂直对齐方式 默认 start
 * @property {String} labelColor           标签内容颜色
 * @property {String} color                value内容颜色
 * @property {Object} cssStyle             自定义样式
 * @property {Object} labelStyle           标签样式
 * @property {Object} valueStyle           value样式
 *
 * @Slots
 * default                                 默认内容
 *
 * @Methods
-->
<template>
  <div :class="['z-line-wrapper', vertical && 'vertical', reverse && 'reverse', labelVerticalAlign && `label-v-${labelVerticalAlign}`, list && 'list']" :style="newStyle">
    <slot></slot>
  </div>
</template>
<script>

export default {
  props: {
    list: { type: Boolean, default: false },
    column: { type: [Number, String], default: 0 },
    min: { type: [Number, String], default: 380 },
    vertical: { type: Boolean, default: false },
    reverse: { type: Boolean, default: false },
    labelWidth: { type: String, default: '' },
    labelAlign: { type: String, default: '' },
    labelVerticalAlign: { type: String, default: '' },
    labelColor: { type: String, default: '' },
    color: { type: String, default: '' },
    cssStyle: { type: Object, default: () => ({}) },
    labelStyle: { type: Object, default: () => ({}) },
    valueStyle: { type: Object, default: () => ({}) }
  },
  provide() {
    return {
      width: this.labelWidth,
      align: this.labelAlign,
      lc: this.labelColor,
      cc: this.color,
      ls: this.labelStyle,
      vs: this.valueStyle
    }
  },
  computed: {
    newStyle() {
      const data = {}
      const col = Number(this.column)
      data['grid-template-columns'] = col ? `repeat(${col}, 1fr)` : `repeat(auto-fill, minmax(${this.min}rem, 1fr))`
      return {
        ...data,
        ...this.cssStyle
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.z-line-wrapper {
  margin: 8rem 0;
  font-size: 14rem;
  &.list {
    margin: 0;
    display: grid;
    gap: 0 20rem;
    // grid-template-columns: repeat(auto-fill, minmax(380rem, 1fr));
  }
}
</style>
